export default __webpack_public_path__ + "static/media/tweezers-black.d82d0ed6.svg";